<template>
  <div class="page-loader">
  <b-spinner label="Spinning" class="loader-spinner"></b-spinner>
  </div>
</template>

<script>
export default {
  name: "loader"
};
</script>

<style scoped></style>
